// PhotoView.jsx

import React, { useEffect, useState } from 'react';

// Utilities
import { getNodeSubtitle } from 'utilities/NodeSubtitle';

// Services
import { resolveImageUrl } from 'services/storage/StorageAccessService';

// CSS
import './PhotoView.css';

/**
 * PhotoView
 *
 * Displays a photo node in the feed.
 * Falls back to node.url if summaries contain only storage paths.
 *
 * @param {object} node - The photo node to display.
 *
 * @returns {ReactNode} The rendered photo feed node or null if invalid input.
 */
const PhotoView = ({ node }) => {

    // ----- STATE ----- //

    const [imageUrl, setImageUrl] = useState(null);

    // ----- EFFECTS ----- //

    useEffect(() => {
        let cancelled = false;
        (async () => {
            const nodeKey = node?.key || null;
            const url = await resolveImageUrl({ nodeKey, url: node?.url || null, storagePath: node?.storagePath || null });
            if (cancelled) return;
            setImageUrl(url || null);
        })();
        return () => {
            cancelled = true;
        };
    }, [node]);

    // Don't render if no node
    if (!node) return null;

    if (!imageUrl) return null;

    // ----- RENDER ----- //

    return (
        <div className="photo-view-container">

            {/* IMAGE */}
            <img
              className="photo-view-image"
              src={imageUrl}
              alt={getNodeSubtitle(node) || 'Photo'}
            />

        </div>
    );
};

// Dev Tools
PhotoView.displayName = 'PhotoView';

export default PhotoView;
